import axios, { AxiosError, AxiosResponse } from 'axios'
import buildPaginationQueryOpts from '@/shared/sort/sorts'

export interface BulkResponse<T> {
  successful: T[];
  error: T[];
}

export default class UserManagementService {
  public get (userId: number): Promise<AxiosResponse> {
    return axios.get(`api/users/${userId}`)
  }

  public create (user): Promise<AxiosResponse> {
    return axios.post('api/users', user)
  }

  public update (user): Promise<AxiosResponse> {
    return axios.put('api/users', user)
  }

  public async remove (userLogin: string): Promise<AxiosResponse> {
    return axios.delete(`api/users/${userLogin}`)
  }

  public async removeBulk (userLogins: string[]): Promise<BulkResponse<string>> {
    function errorManagement (promisesResult): BulkResponse<string> {
      // eslint-disable-next-line id-length
      return promisesResult.reduce((map, result, i) => {
        if (result.status >= 200 && result.status < 300) {
          map.successful.push(userLogins[i])
        } else {
          map.error.push(userLogins[i])
        }
        return map
      }, { successful: [], error: [] })
    }

    const deletePromises = userLogins.reduce((acc, login) => {
      acc.push(this.remove(login).catch((error: AxiosError) => error.response))
      return acc
    }, [])
    const result = await Promise.all(deletePromises).then(errorManagement)
    return result.error.length > 0 ? Promise.reject(result) : result
  }

  public retrieve (req?: {}): Promise<AxiosResponse> {
    return axios.get(`api/users?${buildPaginationQueryOpts(req)}`)
  }

  public retrieveAuthorities (): Promise<AxiosResponse> {
    return axios.get('api/users/authorities')
  }
}
